import { render, staticRenderFns } from "./StepFourAccessories.vue?vue&type=template&id=20f783a4&scoped=true"
import script from "./StepFourAccessories.vue?vue&type=script&lang=js"
export * from "./StepFourAccessories.vue?vue&type=script&lang=js"
import style0 from "./StepFourAccessories.vue?vue&type=style&index=0&id=20f783a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f783a4",
  null
  
)

export default component.exports